module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.medicineType === 'control') ? _c('p', [_vm._v("新增管制藥組")]) : _vm._e(), (_vm.medicineType === 'combo') ? _c('p', [_vm._v("新增套藥"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _c('hr'), _c('form', {
    staticClass: "form-row",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrug($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group col-5"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-5"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genericName),
      expression: "genericName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.genericName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genericName = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false,
      "type": "submit"
    }
  }, [_vm._v("新增")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("代稱*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("全名*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2185c975","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreateSpecialMedicineForm.vue
// module id = 1411
// module chunks = 1